import React, { useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Row,
  Col,
  InputNumber,
  Space,
  Divider,
  Button,
  Popconfirm,
  Tooltip,
  Tag,
  Card,
  Popover,
} from "antd";
import {
  DollarOutlined,
  TeamOutlined,
  CloseOutlined,
  SaveOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import MoneyInput from "./MoneyInput";
import DefendantCheckboxGroup from "./DefendantCheckboxGroup";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { FORM_LAYOUT } from "../constants";
import { optionsInterest } from "../../../../utils/constant/Interest";
import { optionsMonth } from "../../../../utils/constant/MonthSelect";
import { contentPopOver2 } from "../hooks/ContentPopOver";

const { TextArea } = Input;

const FormJudge2 = ({
  form,
  onFinish,
  onFinishFailed,
  onChangeDate,
  checkboxTab2,
  guarantorsOnly,
  handleCheckboxTab2Change,
  onAddDefendantClick,
  handleCancel,
  setTabsKey,
  loading,
  mergedArrow,
  getMergedFormData, // ✅ เพิ่ม prop
  formDataTab1, // ✅ เพิ่ม prop สำหรับแสดงสรุป
  disabledDefendants, // ✅ เพิ่ม
}) => {
  // Track ค่าทั้งสอง field
  const interestRate2Value = Form.useWatch("interestRate2", form);
  const judgementLack2Value = Form.useWatch("judgementLack2", form);
  const interestRateLack2Value = Form.useWatch("interestRateLack2", form);

  // คำนวณว่าควร disable หรือไม่
  const hasInterestRate2 =
    interestRate2Value !== undefined &&
    interestRate2Value !== null &&
    interestRate2Value >= 0;
  const hasJudgementLack2 =
    judgementLack2Value !== undefined &&
    judgementLack2Value !== null &&
    judgementLack2Value !== "" &&
    interestRateLack2Value > 0;

  const isDisabledLack2 = hasInterestRate2;
  const isDisabledInterestRate2 = hasJudgementLack2;

  // ✅ Clear ค่าเมื่อถูก disabled (Optional)
  useEffect(() => {
    if (hasInterestRate2) {
      form.setFieldsValue({
        interestRateLack2: undefined,
      });
    }

    if (hasJudgementLack2) {
      form.setFieldsValue({
        interestRate2: undefined,
      });
    }
  }, [hasInterestRate2, form]);

  const onChangeJudgementLack2Value = (value) => {
    if (value > 0) {
      form.setFieldsValue({
        interestRate2: null,
        interestRateLack2: 15 / 100,
      });
    } else {
      form.setFieldsValue({
        interestRate2: 15 / 100,
        interestRateLack2: null,
      });
    }
  };

  // ✅ Handler submit ที่รวมข้อมูลทั้ง 2 Tab
  const handleSubmitWithMergedData = () => {
    const mergedData = getMergedFormData();
    console.log("📦 Submitting merged data:", mergedData);

    // เรียก onFinish พร้อมข้อมูลที่รวมแล้ว
    onFinish(mergedData);
  };

  // ✅ Handler กลับ Tab1
  const handleBackTab = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setTabsKey("1");
  };

  useEffect(() => {
    if (formDataTab1) {
      console.log("formDataTab1 -->", formDataTab1);

      form.setFieldsValue({
        lawyerFeeEnforce2: formDataTab1.lawyerFeeEnforce1,
        trackingFeeEnforce2: formDataTab1.trackingFeeEnforce1,
        courtFee2: formDataTab1.courtFee1,

        judgement2: formDataTab1.judgement1,
        interestRate2: formDataTab1.interestRate1,
        judgementLack2: formDataTab1.judgementLack1,
        interestRateLack2: formDataTab1.interestRateJudgeLack1,
        dateInterest2: formDataTab1.dateInterest1,
      });
    }
  }, [formDataTab1, form]);

  return (
    <Card style={{ borderRadius: 8 }}>
      <Form
        {...FORM_LAYOUT}
        form={form}
        layout="horizontal"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          governmentOfficer2: [],
        }}
      >
        {/* ✅ แสดงสรุปข้อมูลจาก Tab1 */}
        {formDataTab1 && (
          <>
            <Divider orientation="left">
              📋 สรุปข้อมูลจากคำพิพากษาจำเลยที่ ๑
            </Divider>
            <Card
              size="small"
              style={{
                marginBottom: 24,
                background: "#f6ffed",
                border: "1px solid #b7eb8f",
              }}
            >
              <Row gutter={[16, 8]}>
                <Col span={12}>
                  <strong>ค่าชดใช้แทน:</strong>{" "}
                  {formDataTab1.judgement1
                    ? `${formDataTab1.judgement1.toLocaleString()} บาท`
                    : "-"}
                </Col>
                <Col span={12}>
                  <strong>ต้นเงิน:</strong>{" "}
                  {formDataTab1.judgementLack1
                    ? `${formDataTab1.judgementLack1.toLocaleString()} บาท`
                    : "-"}
                </Col>
                <Col span={12}>
                  <strong>อัตราดอกเบี้ย / ปี:</strong>{" "}
                  {formDataTab1.interestRate1
                    ? `${formDataTab1.interestRate1 * 100}%`
                    : "-"}
                </Col>
                <Col span={12}>
                  <strong>อัตราดอกเบี้ย / ปี:</strong>{" "}
                  {formDataTab1.interestRateJudgeLack1
                    ? `${formDataTab1.interestRateJudgeLack1 * 100}%`
                    : "-"}
                </Col>
              </Row>
            </Card>
          </>
        )}

        <Divider orientation="left">
          <DollarOutlined /> ดอกเบี้ยและค่าขาดประโยชน์
        </Divider>

        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("judgement2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ค่าชดใช้แทน
                </span>
              }
              name="judgement2"
              labelCol={{ span: 12 }}
            >
              <MoneyInput
                placeholder="จำนวนเงินที่จำเลยต้องชำระ"
                // onChange={onChangeJudgement}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("interestRate2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ให้เลือกอัตราดอกเบี้ย/ปี
                </span>
              }
              name="interestRate2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              <Select
                showSearch
                options={optionsInterest}
                optionFilterProp="label"
                size="large"
                style={{ width: "100%" }}
                placeholder="เลือกอัตราดอกเบี้ย"
                popupMatchSelectWidth={false}
                allowClear
                disabled={isDisabledInterestRate2}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("judgementLack2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ต้นเงิน
                </span>
              }
              name="judgementLack2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
            >
              <MoneyInput
                placeholder="ไม่มีไม่ต้องกรอก"
                onChange={onChangeJudgementLack2Value}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("interestRateLack2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ให้เลือกอัตราดอกเบี้ย/ปี
                </span>
              }
              name="interestRateLack2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              <Select
                showSearch
                options={optionsInterest}
                optionFilterProp="label"
                size="large"
                style={{ width: "100%" }}
                placeholder="เลือกอัตราดอกเบี้ย"
                popupMatchSelectWidth={false}
                allowClear
                disabled={isDisabledLack2}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("dateInterest2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  วันเริ่มต้นคิดดอกเบี้ย
                </span>
              }
              name="dateInterest2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
              // rules={[
              //   {
              //     required:
              //       interestRate2Value || interestRateLack2Value ? true : false,
              //     message: "กรุณาใส่วันที่เริ่มคิดดอกเบี้ย} !",
              //   },
              // ]}
            >
              <ThaiDatePicker
                onChange={onChangeDate}
                placeholder="กรุณาเลือกวันที่"
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("delayJudgement2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ไม่เกิน
                </span>
              }
              name="delayJudgement2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              <InputNumber
                min={0}
                suffix="วัน"
                size="large"
                placeholder="ใส่เป็นจำนวนวันเท่านั้น"
                style={{ width: "100%", color: "black" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("costUnless2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ค่าขาดประโยชน์
                </span>
              }
              name="costUnless2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
            >
              <MoneyInput placeholder="ไม่มีไม่ต้องกรอก" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("interestRateCostUnless2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ให้ดอกเบี้ย
                </span>
              }
              name="interestRateCostUnless2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              <Select
                showSearch
                options={optionsInterest}
                optionFilterProp="label"
                size="large"
                style={{ width: "100%" }}
                placeholder="เลือกอัตราดอกเบี้ย"
                popupMatchSelectWidth={false}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("dateInterestCostUnless2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  วันที่คิดดอกค่าคาดประโยชน์
                </span>
              }
              name="dateInterestCostUnless2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
            >
              <ThaiDatePicker
                onChange={onChangeDate}
                placeholder="กรุณาเลือกวันที่"
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("delayCostUnless2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ไม่เกิน
                </span>
              }
              name="delayCostUnless2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              <InputNumber
                min={0}
                suffix="วัน"
                size="large"
                placeholder="ใส่เป็นจำนวนวันเท่านั้น"
                style={{ width: "100%", color: "black" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("costPermonth2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  ค่าขาดประโยชน์เดือนละ
                </span>
              }
              name="costPermonth2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
            >
              <MoneyInput placeholder="ไม่มีไม่ต้องกรอก" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  <Popover
                    content={contentPopOver2("CostUnlessDay2")}
                    title="คำแนะนำ"
                    trigger="click"
                  >
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", cursor: "pointer" }}
                    />
                  </Popover>{" "}
                  จำนวนเดือน
                </span>
              }
              name="CostUnlessDay2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 6 }}
            >
              {/* <InputNumber
                min={0}
                suffix="วัน"
                size="large"
                placeholder="ใส่เป็นจำนวนวันเท่านั้น"
                style={{ width: "100%", color: "black" }}
              /> */}
              <Select
                showSearch
                size="large"
                style={{ width: "100%" }}
                popupMatchSelectWidth={false}
                optionFilterProp="label"
                options={optionsMonth}
                placeholder="เลือกจำนวนเดือน"
                suffix="เดือน"
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        {/* <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
          <Col span={12}>
            <Form.Item
              label="วันที่คิดค่าคาดประโยชน์รายเดือน"
              name="datePermonthInterest2"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
            >
              <ThaiDatePicker
                onChange={onChangeDate}
                placeholder="กรุณาเลือกวันที่"
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row> */}

        {/* ค่าใช้จ่าย */}
        <Divider orientation="left">💵 ศาลสั่งให้ต้องจ่าย</Divider>

        <Form.Item label="ค่าฤชาศาล">
          <Form.Item name="courtFee2" noStyle>
            <MoneyInput
              placeholder="ไม่มีไม่ต้องกรอก"
              style={{ width: "40%" }}
            />
          </Form.Item>
          <Form.Item
            name="courtFeeCheck2"
            valuePropName="checked"
            noStyle
          ></Form.Item>
        </Form.Item>

        <Form.Item label="ค่าติดตาม">
          <Form.Item name="trackingFeeEnforce2" noStyle>
            <MoneyInput
              placeholder="ไม่มีไม่ต้องกรอก"
              style={{ width: "40%" }}
            />
          </Form.Item>
        </Form.Item>

        <Form.Item label="ค่าทนายความ">
          <Form.Item name="lawyerFeeEnforce2" noStyle>
            <MoneyInput
              placeholder="ไม่มีไม่ต้องกรอก"
              style={{ width: "40%" }}
            />
          </Form.Item>
        </Form.Item>

        {/* จำเลยที่ร่วมคำพิพากษา (เฉพาะผู้ค้ำ) */}
        <Divider orientation="left">
          <TeamOutlined /> จำเลยที่ร่วมคำพิพากษานี้ (เฉพาะผู้ค้ำประกัน)
        </Divider>

        <Tooltip
          placement="bottom"
          title="เลือกจำเลยที่โดนพิพากษาในคำตัดสินนี้ !"
          arrow={mergedArrow}
        >
          <Form.Item
            label={
              <Space>
                <TeamOutlined />
                <span>เลือกจำเลย</span>
                {checkboxTab2.length > 0 && (
                  <Tag color="blue">{checkboxTab2.length} คน</Tag>
                )}
              </Space>
            }
            name="governmentOfficer2"
          >
            <DefendantCheckboxGroup
              tabNumber={2}
              defendants={guarantorsOnly}
              selectedValues={checkboxTab2}
              onChange={handleCheckboxTab2Change}
              onAddClick={onAddDefendantClick}
              loading={loading}
              disabledDefendants={disabledDefendants} // ✅ เพิ่ม
            />
          </Form.Item>
        </Tooltip>

        <Form.Item label="หมายเหตุ" name="memo">
          <TextArea
            rows={5}
            placeholder="กรอกหมายเหตุ (ถ้ามี)"
            showCount
            maxLength={500}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 24 }}>
          <div style={{ textAlign: "center", marginTop: 32 }}>
            <Space size="large">
              <Button
                size="large"
                onClick={handleBackTab}
                style={{ minWidth: 120 }}
              >
                ← ย้อนกลับ
              </Button>
              <Button
                size="large"
                onClick={handleCancel}
                icon={<CloseOutlined />}
                style={{ minWidth: 120 }}
              >
                ปิด
              </Button>
              <Popconfirm
                placement="topLeft"
                title="อัพเดทสถานะ"
                description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย !"
                onConfirm={handleSubmitWithMergedData}
                okText="ยืนยัน"
                cancelText="ปิด"
                okButtonProps={{ size: "large" }}
                cancelButtonProps={{ size: "large" }}
              >
                <Button
                  type="primary"
                  size="large"
                  icon={<SaveOutlined />}
                  style={{ minWidth: 120 }}
                >
                  บันทึก
                </Button>
              </Popconfirm>
            </Space>
          </div>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default FormJudge2;
